import React, {useEffect, useMemo, useRef, useState} from 'react';
import SearchablePicker from '../master/SearchablePicker';

import MotorPelak from '../../assets/images/pelak/motor-pelak.jpg';
import FreePelak from '../../assets/images/pelak/freePlate.png';
import BluePelak from '../../assets/images/pelak/pelak_blue.png';
import GreenPelak from '../../assets/images/pelak/pelak_green.png';
import RedPelak from '../../assets/images/pelak/pelak_red.png';
import YellowPelak from '../../assets/images/pelak/pelak_yellow.png';
import ArmyPelak from '../../assets/images/pelak/pelak_army.png';
import Pelak from '../../assets/images/pelak/pelak.png';
// import Pelak from '../../assets/images/pelak/plate22.png'
import DisableImg from '../../assets/images/pelak/malool2.png';
import Modal from "../master/Modal";
import { useTranslation } from 'react-i18next';


export default function Plate({ plate, type, col = 6, change, required , fixed = false , disableType =false ,changeFeild = false,withoutMotor = false}) {
    const { t, i18n } = useTranslation();
    const plateTypes = [
        { title: t('Ordinary'), value: 'car' },
        { title: t('Motor'), value: 'motor' },
        { title: t('Free'), value: 'free' }
    ];

    const dataProps = useMemo(() => {
        const value = (type === 'car' && (plate.plate_right && plate.plate_left && plate.plate_iran && plate.plate_center))
            || (type === 'motor' && (plate.plate_right && plate.plate_left))
            || (type === 'free' && (plate.plate_iran && plate.plate_left));
        return JSON.stringify({ value, required, label: t('Plate') });
    }, [required, plate, type]);
    const [plateCenterSearch, setPlateCenterSearch] = useState(false)
    const plateCenter = useRef()
    useEffect(() => {
        function handleClickOutside(event) {
            if (plateCenter.current && !plateCenter.current.contains(event.target)) {
                setPlateCenterSearch(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [plateCenter]);

    //const alphabetPlate = hardCopy(alphabet);
    const alphabetPlate = ['الف', 'ب', 'پ', 'ت', 'ث', 'ج', 'چ', 'ه', 'خ', 'د', 'ذ', 'ر', 'ز', 'س', 'ش', 'ص', 'ض', 'ط', 'ظ', 'ع', 'غ', 'ف', 'ق', 'ک', 'گ', 'ل', 'م', 'ن', 'و', 'ه', 'ی', 'S',' D'];
    //alphabetPlate.push('S',' D');
    const specialPlate = ['ف','الف', 'ز', 'ث' ,'پ']
    function checkIsfull (val,part) {
        if(type === 'car'){
        changeFeild && changeFeild(false)
        if(part === 'plate_iran'){
            changeFeild && val.length === 2 && changeFeild(true) /// focus next feild in plans component
        }else if(part === 'plate_right'){
            val.length === 3 && document.getElementById('plate_iran').focus();
        }else if(part === 'plate_left'){
            if(val.length === 2) {
                document.getElementById('plate_left').blur();
                setPlateCenterSearch(true)
            } 
        }else if(part === 'plate_center'){
            val && document.getElementById('plate_right').focus();
        }
        }
        if(type === 'motor'){
            if(part === 'plate_left'){
                val.length === 3 && document.getElementById('motor_plate_right').focus();
            }
        }
        if(type === 'free'){
            if(part === 'plate_left'){
                val.length === 5 && document.getElementById('free_plate_iran').focus();
            }
        }
        change(val,part);
    }
    function emptyParts(){
        for (const [key, value] of Object.entries(plate)) {
            change('',key)
          }
    }

    return (
        <>
            {!disableType &&
            <SearchablePicker
                label={t('Plate type')}
                value={type}
                data={withoutMotor ? plateTypes.filter(val=> val.value !== 'motor') :plateTypes}
                titleKey='title'
                valueKey='value'
                rtl={i18n.language !== 'en'}
                col={col}
                required={required}
                onSelect={type => {change(type, 'plate_type');emptyParts()}}
                //style={`${type === 'motor' && {height: '40px'}}`}
                disabled={fixed}
            />
            }
            <div className={`col-${col}`} data-props={t(dataProps)}>
                <div className='mt10 mb5'>
                    <label>
                        {
                            required &&
                            <span className='required-icon'>* </span>
                        }
                        {t('Plate')}
                    </label>
                </div>
                <div className='plate'>
                    {
                        type === 'car' &&
                        <div className='pelak-img'>
                            <img
                                alt='car-pelak'
                                className='car-pelak-img'
                                src={`${(plate.plate_center === 'ف' || plate.plate_center === 'ز') ? BluePelak :
                                    plate.plate_center === 'ش' ? ArmyPelak :
                                        (plate.plate_center === 'ک' || plate.plate_center === 'ت' || plate.plate_center === 'ع') ? YellowPelak :
                                            (plate.plate_center === 'پ' || plate.plate_center === 'ث') ? GreenPelak :
                                                plate.plate_center === 'الف' ? RedPelak : Pelak}                    
                    `
                                }
                            />
                            <div className={`pelak-input ${specialPlate.includes(plate.plate_center)? 'text-color': ''}`}>
                            <input
                            className='iran-input'
                                style={{ width: '17%' }}
                                type='text'
                                maxLength='2'
                                inputMode='numeric'
                                placeholder='--'
                                value={plate.plate_iran || ''}
                                onChange={e => checkIsfull(e.target.value,'plate_iran')}
                                // onChange={e => change(e.target.value, 'plate_iran')}
                                disabled={fixed}
                                id='plate_iran'
                            />
                            <input
                            className='right-input'
                                style={{ width: '20%' }}
                                type='text'
                                maxLength='3'
                                inputMode='numeric'
                                placeholder='---'
                                value={plate.plate_right || ''}
                                onChange={e => checkIsfull(e.target.value, 'plate_right')}
                                // onChange={e => change(e.target.value, 'plate_right')}
                                disabled={fixed}
                                id='plate_right'
                            />
                            <div style={{ width: '23%' }} className={`center-input ${!plate.plate_center ? 'border-input':''}`} onClick={()=>!fixed && setPlateCenterSearch(true)}>
                                <span>{plate.plate_center === 'ژ' ? <img className='pelak-disable-img' alt="disable" src={DisableImg}/> : plate.plate_center}</span>
                                {/* old version */}
                                {/*<SearchablePicker*/}
                                {/*    className='p0'*/}
                                {/*    value={plate.plate_center}*/}
                                {/*    data={alphabet}*/}
                                {/*    rtl*/}
                                {/*    col={12}*/}
                                {/*    onSelect={val => change(val, 'plate_center')}*/}
                                {/*    placeholder='-'*/}
                                {/*/>*/}
                                {/* old version */}

                            </div>
                            <input
                            className='left-input'
                                style={{ width: '16%' }}
                                type='text'
                                maxLength='2'
                                inputMode='numeric'
                                placeholder='--'
                                value={plate.plate_left || ''}
                                onChange={e => checkIsfull(e.target.value, 'plate_left')}
                                // onChange={e => change(e.target.value, 'plate_left')}
                                disabled={fixed}
                                id='plate_left'
                            />
                            </div>
                        </div>
                    }
                    {/* new version */}
                     {/* {
                        type === 'car' &&
                        <div className='pelak-img'>
                            <img
                                alt='car-pelak'
                                src={Pelak}
                                className={`new-car-pelak-img
                                ${(plate.plate_center === 'ف' || plate.plate_center === 'ز') ? 'blue' :
                                    plate.plate_center === 'ش' ? 'brown' :
                                        (plate.plate_center === 'ک' || plate.plate_center === 'ت' || plate.plate_center === 'ع') ? 'yellow' :
                                            (plate.plate_center === 'پ' || plate.plate_center === 'ث') ? 'green' :
                                                plate.plate_center === 'الف' ? 'red' : 'white'}                    
                    `
                                }
                            />
                            <div className={`new-pelak-input ${specialPlate.includes(plate.plate_center)? 'text-color': ''}`}>
                            <input
                            className='iran-input'
                                style={{ width: '17%' }}
                                type='text'
                                maxLength='2'
                                inputMode='numeric'
                                placeholder='--'
                                value={plate.plate_iran || ''}
                                onChange={e => change(e.target.value, 'plate_iran')}
                            />
                            <input
                            className='right-input'
                                style={{ width: '20%' }}
                                type='text'
                                maxLength='3'
                                inputMode='numeric'
                                placeholder='---'
                                value={plate.plate_right || ''}
                                onChange={e => change(e.target.value, 'plate_right')}
                            />
                            <div style={{ width: '23%' }} className={`center-input ${!plate.plate_center ? 'border-input':''}`} onClick={()=>setPlateCenterSearch(true)}>
                                <span>{plate.plate_center === 'ژ' ? <img className='pelak-disable-img' alt="disable" src={DisableImg}/> : plate.plate_center}</span>  */}
                                {/* old version */}
                                {/*<SearchablePicker*/}
                                {/*    className='p0'*/}
                                {/*    value={plate.plate_center}*/}
                                {/*    data={alphabet}*/}
                                {/*    rtl*/}
                                {/*    col={12}*/}
                                {/*    onSelect={val => change(val, 'plate_center')}*/}
                                {/*    placeholder='-'*/}
                                {/*/>*/}
                                {/* old version */}

                            {/* </div>
                            <input
                            className='left-input'
                                style={{ width: '16%' }}
                                type='text'
                                maxLength='2'
                                inputMode='numeric'
                                placeholder='--'
                                value={plate.plate_left || ''}
                                onChange={e => change(e.target.value, 'plate_left')}
                            />
                            </div>
                        </div>
                    } */}
                    {
                        type === 'motor' &&
                        <div className='pelak-img'>
                            <img
                                alt='motor'
                                className='motor-pelak-img'
                                src={MotorPelak}
                            />
                            <div className='motor-pelak-input'>

                            {/*<span style={{ width: '10%' }}>/</span>*/}
                            <input
                                className='up-input'
                                style={{ width: '35%' }}
                                maxLength='3'
                                inputMode='numeric'
                                placeholder='---'
                                type='text'
                                value={plate.plate_left || ''}
                                onChange={e => checkIsfull(e.target.value, 'plate_left')}
                                id='motor_plate_left'
                                // onChange={e => change(e.target.value, 'plate_left')}
                            />
                            <input
                                className='down-input'
                                style={{ width: '55%' }}
                                type='text'
                                maxLength='5'
                                inputMode='numeric'
                                placeholder='-----'
                                value={plate.plate_right || ''}
                                onChange={e => checkIsfull(e.target.value, 'plate_right')}
                                // onChange={e => change(e.target.value, 'plate_right')}
                                id='motor_plate_right'
                            />
                            </div>
                        </div>
                    }
                    {
                        type === 'free' &&
                        <div className='pelak-img'>
                            <img
                                alt='motor'
                                className='car-pelak-img'
                                src={FreePelak}
                                style={{borderRadius:'7px'}}
                            />
                            <div className='pelak-input'>
                            <input
                                className='iran-input'
                                style={{ width: '11%' }}
                                type='text'
                                maxLength='2'
                                inputMode='numeric'
                                placeholder='--'
                                value={plate.plate_iran || ''}
                                onChange={e => checkIsfull(e.target.value, 'plate_iran')}
                                // onChange={e => change(e.target.value, 'plate_iran')}
                                id='free_plate_iran'
                            />
                            {/*<span style={{ width: '10%' }}>/</span>*/}
                            <input
                                className='free-right-input'
                                style={{ width: '50%' }}
                                type='text'
                                maxLength='5'
                                inputMode='numeric'
                                placeholder='-----'
                                value={plate.plate_left || ''}
                                onChange={e => checkIsfull(e.target.value, 'plate_left')}
                                // onChange={e => change(e.target.value, 'plate_left')}
                                id='free_plate_left'
                            />
                            </div>
                        </div>
                    }
                </div>
            </div>
            {plateCenterSearch &&(
                <>
                    <Modal visible={plateCenterSearch}>
                    
                        <div className={`plate-modal ${plateCenterSearch ? 'active': ''}`} ref={plateCenter}>
                            <div className='plateCenter-pick btn-white-purple'>
                                {alphabetPlate.map((item,i)=>(
                                    <div className='plate_center' key={i}
                                         onClick={()=>{
                                             checkIsfull(item, 'plate_center')
                                            //  change(item, 'plate_center')
                                             setPlateCenterSearch(false)
                                         }}>
                                        {item}
                                    </div>
                                ))}
                                <div
                                    className='plate_center'
                                    onClick={()=>{
                                        checkIsfull('ژ', 'plate_center')
                                        // change('ژ', 'plate_center')
                                        setPlateCenterSearch(false)
                                    }}
                                >
                                    <img className='disable-img' alt="disable" src={DisableImg}/>
                                </div>
                            </div>

                            {/* <div className='text-center'>
                                <button className='btn btn-red btn-circle' onClick={()=>setPlateCenterSearch(false)}>{t('Close')}</button>
                            </div> */}

                        </div>
                        
                    </Modal>

                </>
            )}
        </>
    );

}
